import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col" };
const _hoisted_3 = { class: "col col--half" };
const _hoisted_4 = { class: "col col--half" };
const _hoisted_5 = {
    key: 0,
    class: "col"
};
import PhoneControl from "../../../components/form/PhoneControl.vue";
import FormCheckbox from "../../../components/form/FormCheckbox.vue";
import FormInput from "../../../components/form/FormInput.vue";
import FormBlock from "../../../components/form/FormBlock.vue";
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactsBlock',
    props: {
        allowSkipCall: Boolean,
        formData: { type: Object, default: {} },
        errors: { type: Object, default: {} },
        token: String,
    },
    setup(__props) {
        const props = __props;
        const name = ref(props.formData.NAME);
        const email = ref(props.formData.EMAIL);
        const phone = ref(props.formData.PHONE);
        const skipCall = ref(props.formData.skip_call);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(FormBlock, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(FormInput, {
                                name: "NAME",
                                label: "Укажите ваше ФИО полностью",
                                placeholder: "Иванов Иван Иванович",
                                error: __props.errors.NAME,
                                required: "",
                                modelValue: name.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event))
                            }, null, 8 /* PROPS */, ["error", "modelValue"])
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(FormInput, {
                                name: "PHONE",
                                label: "Номер телефона",
                                error: __props.errors.PHONE,
                                required: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(PhoneControl, {
                                        name: "PHONE",
                                        modelValue: phone.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((phone).value = $event))
                                    }, null, 8 /* PROPS */, ["modelValue"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["error"])
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(FormInput, {
                                name: "EMAIL",
                                type: "email",
                                label: "Эл. почта",
                                placeholder: "perfume-lover@example.com",
                                error: __props.errors.EMAIL,
                                required: "",
                                modelValue: email.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((email).value = $event))
                            }, null, 8 /* PROPS */, ["error", "modelValue"])
                        ]),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        (__props.allowSkipCall)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(FormCheckbox, {
                                    name: "skip_call",
                                    label: "Не перезванивайте мне для подтверждения заказа",
                                    modelValue: skipCall.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((skipCall).value = $event))
                                }, null, 8 /* PROPS */, ["modelValue"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
